export { default } from './GrafikPDFDownload';



// WEBPACK FOOTER //
// ./src/components/GrafikPDFDownload/index.js